import { ISessionKeys } from "@/models";
import { GBSCError } from "@/models/GBSCError";

import {
  IAccessToken,
  IGuestUserLoginResponse,
  IMobileVerifyOrSendOTPReq,
  IMobileVerifyOrSendOTPRes,
  IOTPVerifyReq,
  IOTPVerifyRes,
} from "@/models/onboarding";

import { storage } from "@/utils/Storage";
import { get, post } from "@/utils/TypedApi";

import {
  APIEndpoint,
  IAPIStatusCode,
  IAPIStatusType,
  messages,
} from "@/utils/apis/APIEndpointConfig";

export const mobileVerifyOrSendOTPApi = async (
  requestData: IMobileVerifyOrSendOTPReq
): Promise<IMobileVerifyOrSendOTPRes | GBSCError> => {
  try {
    const response = await post<IMobileVerifyOrSendOTPRes>(
      APIEndpoint.onBoarding.login,
      requestData
    );
    if (response.type === IAPIStatusType.SUCCESS) {
      return response.data;
    }

    const { errorMessage, message, statusCode } = response;
    return new GBSCError(errorMessage, message, statusCode);
  } catch (ex) {
    console.log(ex);
  }

  return new GBSCError(
    IAPIStatusType.ERROR,
    messages.somethingWentWrong,
    IAPIStatusCode.INTERNAL_SERVER_ERROR
  );
};

export const OTPVerifyApi = async (
  requestData: IOTPVerifyReq
): Promise<IOTPVerifyRes | GBSCError> => {
  try {
    const response = await post<IOTPVerifyRes>(
      APIEndpoint.onBoarding.otpVerify,
      requestData,
      { withCredentials: true }
    );
    if (response.type === IAPIStatusType.SUCCESS) {
      return response.data;
    }
    const { errorMessage, message, statusCode } = response;
    return new GBSCError(errorMessage, message, statusCode);
  } catch (ex) {
    console.log(ex);
  }

  return new GBSCError(
    IAPIStatusType.ERROR,
    messages.somethingWentWrong,
    IAPIStatusCode.INTERNAL_SERVER_ERROR
  );
};

export const getAccessTokenApi = async (): Promise<
  IAccessToken | GBSCError
> => {
  try {
    const response: any = await get<IAccessToken>(APIEndpoint.accessToken);

    if (response.statusCode === IAPIStatusCode.UNAUTHENTICATED) {
      const response = await guestUserLoginApi();
      if ("result" in response) {
        const { role, token } = response.result;
        const sessionKeys = [ISessionKeys.TOKEN, ISessionKeys.ROLE_TYPE];
        const values = [token, role];
        sessionKeys.map((key, index) =>
          storage.setSessionToken(key, values[index])
        );
      }
    } else {
      if (response.type === IAPIStatusType.SUCCESS) {
        return response.data;
      }
    }

    const { errorMessage, message, statusCode } = response;
    return new GBSCError(errorMessage, message, statusCode);
  } catch (ex) {
    console.log(ex);
  }

  return new GBSCError(
    IAPIStatusType.ERROR,
    messages.somethingWentWrong,
    IAPIStatusCode.INTERNAL_SERVER_ERROR
  );
};

export const guestUserLoginApi = async (): Promise<
  IGuestUserLoginResponse | GBSCError
> => {
  try {
    const response = await post<IGuestUserLoginResponse>(
      APIEndpoint.guestUserLogin,
      {},
      { withCredentials: true }
    );
    if (response.type === IAPIStatusType.SUCCESS) {
      return response.data;
    }

    const { errorMessage, message, statusCode } = response;
    return new GBSCError(errorMessage, message, statusCode);
  } catch (ex) {
    console.log(ex);
  }

  return new GBSCError(
    IAPIStatusType.ERROR,
    messages.somethingWentWrong,
    IAPIStatusCode.INTERNAL_SERVER_ERROR
  );
};
